export const DEV = import.meta.env.DEV;
// Maybe later?
export const STEAM = false;
export const MAC = window.navigator.platform === "MacIntel";
